import React, { useEffect } from "react";
import Seo from "../../components/seo/Seo";
import RootLayout from "../../layouts/RootLayout";

import Hero from "../../components/Hero";
import ProblemSolution from "../../components/ProblemSolution";
import DashboardFeatures from "../../components/DashboardFeatures";
import MidCta from "../../components/MidCta";
import Process from "../../components/Process";
import SuccessStory from "../../components/SuccessStory";
import About from "../../components/About";
import Faq from "../../components/Faq";
import Cta from "../../components/Cta";

const Home = () => {
    useEffect(() => {
        document.title = "Trustpoint Healthcare Solutions | Revenue Cycle Management";
        
        if (window.AOS) {
            window.AOS.init({
                duration: 800,
                once: true,
                offset: 100
            });
        }
    }, []);

    return (
        <RootLayout>
            <Seo
                title="Trustpoint Healthcare Solutions | Revenue Cycle Management"
                description="Revenue Cycle Management Built by Clinicians, for Clinicians."
                pathname="/"
            />

            <main>
                <Hero />
                <ProblemSolution />
                <DashboardFeatures />
                <MidCta />
                <Process />
                <SuccessStory />
                <About />
                <Faq />
                <Cta />
            </main>
        </RootLayout>
    );
};


export default Home;
